import { Form, Switch } from "antd";
import React from "react";

const Smoker: React.FC = () => {
  return (
    <>
      <Form.Item
        name={["subjectMetric", "isSmoker"]}
        label="Smoking"
        valuePropName="checked"
      >
        <Switch defaultValue={false} />
      </Form.Item>
      <Form.Item name={["subjectMetric", "id"]} label="Smoking" hidden />
    </>
  );
};

export default Smoker;
